import React, { memo } from "react";
import { View, TouchableOpacity, StyleSheet } from "react-native";
import Text from "@components/AppText";
import Caret from "@assets/svg/Caret";
import colors from "@constants/color";
import metrics from "@constants/metrics";
import CustomText from "@components/CustomText";
import DownArrow from "@assets/svg/Wallet/DownArrow";
import CMOTruck from "@assets/svg/CMOTruck";
import getStatusColor from "../../utils/getStatusColor";

// Props list

// a - orderCommissionView(boolean) => For order Commission View

// b - secondaryStats(boolean) => Is there's any secondary stats available

// c - secondaryStatsData(Array<object>) => If secondary stats is available and data for displaying it.

// d - title => Displaying main title of type card

// e - orderCommissionData(
// { username: string; orderNumber: string | number, date: string, status: string }
// ) => of ordercommisonView is true and data for displaying it

// f - normalCard(boolean) -> If card will be visible on the wallet home

// g - otherCommissionsView(boolean) -> If card is for bonus, referral and refund view

// h - otherCommissionsData(object) => Data for other commissions view

const StatsCard = memo((props) => {
  const {
    normalCard = false,
    normalCardData = {},
    secondaryStats = false,
    secondaryStatsData = [],
    orderCommissionView = false,
    orderCommissionData = {},
    otherCommissionsView = false,
    otherCommissionsData = {},
    handlePress = null,
    shouldShowPassbookType = false,
    typeHi = "",
    orderCommissionNormalData = null,
    containerStyle = {},
  } = props;
  const {
    username,
    orderNumber,
    date,
    status,
    statusKey: orderCommmissionStatusKey,
    isDeliveredByCMO = false,
    title,
  } = orderCommissionData;

  const {
    title: commissionTitle,
    date: commissionDate,
    status: commmissionStatus,
    commission: commissionAmount,
    statusKey,
  } = otherCommissionsData;

  const { title: normalTitle, value: normalValue } = normalCardData;

  const userName = username
    ? username.split(" ").length > 2
      ? `${username.split(" ").slice(0, 2).join(" ")}...`
      : username
    : "";

  const getCommissionStyle = (statusKey) => {
    if (statusKey === "errored" || statusKey === "cancelled") {
      return {
        color: "rgba(0,0,0,0.56)",
        textDecorationLine: "line-through",
      };
    }
    return { color: "rgba(0,0,0,0.86)" };
  };

  return (
    <View style={[styles.cardContainer, containerStyle]}>
      {shouldShowPassbookType && (
        <View style={[styles.beLikeRow, { borderWidth: 0, marginBottom: 8 }]}>
          <CustomText
            style={{
              color: colors.lightBlack,
              flex:
                Array.isArray(secondaryStatsData) &&
                secondaryStatsData.length > 0
                  ? 0
                  : 1,
            }}
            variant="caption_2"
          >
            {typeHi}
          </CustomText>
          {Array.isArray(secondaryStatsData) &&
            secondaryStatsData.length > 0 &&
            secondaryStatsData.map((stat, index) =>
              index == 0 ? (
                <View
                  style={{
                    flexDirection: "row",
                    marginTop: 2,
                    flex: 1,
                    alignItems: "center",
                  }}
                >
                  <CustomText
                    style={[styles.primaryText, styles.salesText]}
                    variant="caption_1"
                  >
                    •({stat.title} :
                  </CustomText>

                  <CustomText
                    style={[
                      styles.primaryText,
                      styles.salesText,
                      { marginRight: 4 },
                    ]}
                    variant="caption_1"
                  >
                    {stat.value || 0})
                  </CustomText>
                  {isDeliveredByCMO && <CMOTruck />}
                </View>
              ) : (
                <></>
              ),
            )}
          <DownArrow
            fill={getStatusColor(orderCommmissionStatusKey)}
            style={{ marginRight: 5 }}
          />
          <CustomText style={styles.primaryText} variant="body_text_3">
            {date || commissionDate}
          </CustomText>
        </View>
      )}
      <View
        style={[
          styles.beLikeRow,
          {
            justifyContent: "space-between",
            borderWidth: 0,
            borderColor: "lime",
          },
        ]}
      >
        {otherCommissionsView ? (
          <>
            <View style={{ width: "70%", alignSelf: "flex-start" }}>
              {!shouldShowPassbookType && (
                <CustomText
                  style={{ marginBottom: 5, color: colors.lightMediumBlack }}
                  variant="body_text_4"
                >
                  {commissionDate}
                </CustomText>
              )}
              <CustomText style={[styles.secondaryText]} variant="body_text_3">
                {commissionTitle}
              </CustomText>
            </View>
            <View style={{ alignItems: "flex-end" }}>
              <CustomText variant="subtitle_16">₹{commissionAmount}</CustomText>

              <CustomText
                style={{
                  color: getStatusColor(statusKey),
                }}
                variant="caption_1"
              >
                {commmissionStatus}
              </CustomText>
            </View>
          </>
        ) : null}

        {orderCommissionView ? (
          <View style={{ width: "100%" }}>
            <>
              <TouchableOpacity
                style={styles.beLikeRow}
                onPress={() => handlePress(orderCommissionData)}
              >
                <CustomText
                  style={{ color: "rgba(0, 0, 0, 0.65)" }}
                  variant="body_text_3"
                >
                  {orderNumber}
                </CustomText>

                <View style={{ flex: 1 }}>
                  <Caret strokeColor={colors.primary} width={18} height={18} />
                </View>
                {Array.isArray(secondaryStatsData) &&
                secondaryStatsData.length > 0
                  ? secondaryStatsData.map(
                      (stat, index) =>
                        index == 1 && (
                          <CustomText
                            style={{
                              lineHeight: 26,
                              ...getCommissionStyle(
                                orderCommissionData.statusKey,
                              ),
                            }}
                            variant="subtitle_16"
                          >
                            {stat.value}
                          </CustomText>
                        ),
                    )
                  : null}
              </TouchableOpacity>
              {!shouldShowPassbookType && (
                <CustomText style={styles.primaryText} variant="body_text_3">
                  {date}
                </CustomText>
              )}
            </>
            <View style={{ flexDirection: "row" }}>
              <CustomText variant="body_text_3">
                {userName && (
                  <>
                    <CustomText
                      style={{ color: "rgba(0, 0, 0, 0.65)", flex: 1 }}
                      variant="body_text_2"
                    >
                      {userName}
                    </CustomText>
                  </>
                )}
              </CustomText>
              {title ? (
                <CustomText
                  style={{ color: "rgba(0, 0, 0, 0.65)", flex: 1 }}
                  variant="body_text_2"
                >
                  {title || ""}
                </CustomText>
              ) : null}
              <View style={{ marginLeft: "auto" }}>
                <CustomText
                  style={{
                    color: getStatusColor(orderCommmissionStatusKey),
                    marginTop: 5,
                  }}
                  variant="caption_1"
                >
                  {status}
                </CustomText>
              </View>
            </View>
          </View>
        ) : null}

        {normalCard ? (
          <>
            <View style={{ flexDirection: "row", alignItems: "center" }}>
              <CustomText style={styles.primaryText} variant="body_text_3">
                {normalTitle}{" "}
              </CustomText>

              {Array.isArray(orderCommissionNormalData) &&
              orderCommissionNormalData.length > 0 ? (
                <CustomText style={styles.primaryText} variant="body_text_2">
                  (
                  <CustomText>
                    {orderCommissionNormalData[0].title} :{" "}
                  </CustomText>
                  <CustomText>
                    {orderCommissionNormalData[0].value || ""}
                  </CustomText>
                  )
                </CustomText>
              ) : null}
            </View>
            {handlePress && (
              <TouchableOpacity style={styles.beLikeRow} onPress={handlePress}>
                <CustomText
                  variant="caption_1"
                  style={{ color: colors.primary, paddingRight: 5 }}
                >
                  सभी देखें
                </CustomText>

                <Caret strokeColor={colors.primary} width={20} height={25} />
              </TouchableOpacity>
            )}
          </>
        ) : null}
      </View>
      <View style={styles.beLikeRow}>
        {secondaryStats ? (
          <></>
        ) : normalCard ? (
          <View style={{ marginVertical: 5 }}>
            <CustomText
              variant="title_20"
              style={{ color: colors.primary, paddingRight: 5 }}
            >
              {normalValue}
            </CustomText>
          </View>
        ) : null}
      </View>
    </View>
  );
});

const styles = StyleSheet.create({
  beLikeRow: {
    flexDirection: "row",
    alignItems: "center",
  },
  cardContainer: {
    // padding: 15,
    paddingVertical: 12,
    paddingHorizontal: 15,
    borderWidth: 1,
    borderRadius: 6,
    borderColor: "rgba(0, 0, 0, 0.1)",
    marginTop: 5,
    width: "100%",
    // width: metrics.screenWidth - 30
  },
  primaryText: {
    color: "rgba(0, 0, 0, 0.56)",
  },
  secondaryStats: {
    marginRight: metrics.screenWidth * 0.2,
  },
  salesText: {
    fontSize: 12,
  },
  secondaryText: {
    color: "rgba(0, 0, 0, 0.87)",
  },
});

export default StatsCard;
